// extracted by mini-css-extract-plugin
export default {"inputtextcontainer":"InputText_inputtextcontainer__Wfdr8","inputtext":"InputText_inputtext__z48Ts"};